import { Box, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CreateStepSelector from '../../components/createPortfolio/CreateStepSelector';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { initEdit, initEmptyCreation, initWithFund } from '../../store/actions/createPortfolio';
import { AUTHENTICATED_ROUTES } from '../../resources/routes-constants';
import ConfirmationForm from '../../components/common/ConfirmationForm';
import { useTranslation } from 'react-i18next';

const CreatePortfolioPage: React.FC = () => {
    const { id, fundid, step } = useParams();
    const [ showGoBackToStep, setShowGoBackToStep] = useState(false);
    const isInitializing = useAppSelector(state => state.createPortfolio.initializing);
    const portfolio = useAppSelector(state => state.createPortfolio.portfolio);
    const dispatch = useAppDispatch();
    const fundidAsNumber = parseInt(fundid as string);
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if (id !== undefined) {
            if (portfolio.id !== id) {
                dispatch(initEdit(id as string));
            }
        } else {
            if (!isNaN(fundidAsNumber)) {
                dispatch(initWithFund(fundidAsNumber)).then(({payload}) => {
                    navigate(AUTHENTICATED_ROUTES.PORTFOLIO_EDIT_ROUTE.replace(":id", (payload as any).id), { replace: true });
                })
            } else {
                dispatch(initEmptyCreation());
            }
        }
    }, [dispatch, navigate, fundidAsNumber]);

    useEffect(() => {
        if (!isInitializing && portfolio.id === id && portfolio.step > 0 && step === undefined){
            setShowGoBackToStep(true);
        }
    }, [isInitializing]);

    const onStartFromBeginning = () =>{
        setShowGoBackToStep(false);
    }
    const onGoToLastStep = () =>{
        setShowGoBackToStep(false);
        navigate(AUTHENTICATED_ROUTES.PORTFOLIO_EDIT_STEP_ROUTE.replace(":id", `${portfolio.id}`).replace(":step", `${portfolio.step}`), { replace: true});
    }

    return <Box display={"flex"} width={"100%"} justifyContent={"center"} overflow={"auto"}>
        <Box display={"flex"} flexDirection={"column"} maxWidth={"1386px"} margin={"50px 56px"}>
            {isInitializing ? <CircularProgress /> : <CreateStepSelector />}
            {showGoBackToStep && <ConfirmationForm content={t('CreatePortfolioGoBackToStepText')} title={t('CreatePortfolioGoBackToStepTitle')}
                confirmAction={[
                    {action:onStartFromBeginning, title: t('CreatePortfolioGoBackToStepBeginning'), type: 'secondary'},
                    {action:onGoToLastStep, title: t('CreatePortfolioGoBackToStepLatest'), type: 'primary'}
                ]} onClose={onStartFromBeginning} />}
        </Box>
    </Box>
}

export default CreatePortfolioPage;